/**
 * 도움말
 */
import { Fragment } from 'react';
import { useLoaderData } from 'react-router-dom';
import Header from '@features/content/Header';
import { apiSearchSlice } from '@features/api/apiSearchSlice';
import { setRequestToSearchParams } from '@utils/index';
import { ALIAS, CUR_NETWORK, NETWORK } from '@constants/index';
import { getLocalData } from '@features/api/apiLocalSlice';
import NoData from '../../components/contents/common/NoData';
import { useAppSelector } from '@hooks/defineRtkTypedHook';
import { selectL10N, setAlias } from '@features/ui/UiSlice';
import FaqArticle from '@components/contents/article/FaqArticle';
import Paging from '@components/contents/common/Paging';
import type { IContentData, IFaq, ILoaderData, ISetFaq } from '@type/index';

export const FaqLoader =
  (dispatch, option: IOption) =>
  async ({ request }): Promise<ISetFaq | null> => {
    const searchParams = setRequestToSearchParams(request);

    // alias 변경
    dispatch(setAlias(ALIAS.FAQ));

    if (!searchParams?.keyword) {
      return null;
    }

    return CUR_NETWORK === NETWORK.OPDEV
      ? await getLocalData(ALIAS.FAQ, searchParams)
      : await dispatch(apiSearchSlice?.endpoints?.getFaq?.initiate({ option, params: searchParams }));
  };

interface IContentComponentProps {
  data: IContentData<IFaq>;
}
const ContentComponent = ({ data }: IContentComponentProps) => {
  const l10n = useAppSelector(selectL10N);

  return (
    <Fragment>
      <div className="search-content">
        <ul className="column column-2">
          {data?.list.map((item, i) => (
            <li key={i} className="search-item">
              <FaqArticle item={item} l10n={l10n!} />
            </li>
          ))}
        </ul>
      </div>
      <Paging endPage={data?.pagination?.endPage} showPage={5} l10n={l10n!} />
    </Fragment>
  );
};

const Faq = () => {
  const { data, isLoading, isError } = (useLoaderData() as ILoaderData<IContentData<IFaq>>) || {};

  console.log('Faq Data', data);

  if (isError || !Array.isArray(data?.list) || data?.list?.length === 0) {
    return <NoData />;
  }

  return (
    <div className="search-result faq">
      <Header totalCount={data?.pagination?.total} />
      <ContentComponent data={data} />
    </div>
  );
};

export default Faq;
